<template>
  <div class="btn-group">
    <button
      type="button"
      id="download-report"
      class="btn btn-primary dropdown-toggle"
      data-toggle="dropdown"
      aria-expanded="false"
    >
      Download
    </button>
    <div class="dropdown-menu">
      <a
        class="dropdown-item"
        href="#"
        @click.prevent="downloadBrokerNotification"
        >Broker Notification</a
      >
      <a class="dropdown-item" href="#" @click.prevent="downloadEcn">ECN</a>
      <a class="dropdown-item" href="#" @click.prevent="downloadInvoice"
        >Protocol Invoice</a
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  methods: {
    downloadBrokerNotification() {
      this.downloading = true;

      window.Ajax.download(`/incidents/${this.incident}/download`)
        .then(() => {
          this.downloading = false;
        })
        .catch(() => {
          this.downloading = false;

          window.toastify.error(
            'Sorry, there was a problem downloading the broker notification'
          );
        });
    },

    downloadEcn() {
      this.downloading = true;

      window.Ajax.download(`/incidents/${this.incident}/protocol-ecn`)
        .then(() => {
          this.downloading = false;
        })
        .catch(() => {
          this.downloading = false;

          window.toastify.error(
            'Sorry, there was a problem downloading the ECN'
          );
        });
    },

    downloadInvoice() {
      this.downloading = true;

      window.Ajax.download(`/incidents/${this.incident}/protocol-invoice`)
        .then(() => {
          this.downloading = false;
        })
        .catch(() => {
          this.downloading = false;

          window.toastify.error(
            'Sorry, there was a problem downloading the invoice'
          );
        });
    }
  }
};
</script>
